<div class="location-data">   
    <div *ngIf="finalActionRequiredList?.length > 0 || escalatedTo?.length > 0">
        <div class="label">
            <label>
                Action Needed
            </label>
        </div>
        <div class="information">
            <div class="text">
                <div *ngFor="let item of finalActionRequiredList">
                    <img src="../../../../assets/images/cox-icons/Error-Icon.svg" alt="Icon">
                    {{item}}
                </div>
                <div *ngIf="escalatedTo">
                    <img src="../../../../assets/images/cox-icons/Error-Icon.svg" alt="Icon">
                    {{escalatedTo}}
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="holdStatus || status || offsite">
        <div class="label">
            <label>
                Status Information
            </label>
        </div>
        <div class="information">
            <div class="text">
                <p *ngIf="holdStatus"><span class="holdIcon"><img src="../../../../assets/images/cox-icons/blue-info-icon.svg" alt="Icon"></span><span>On Hold - </span>{{ holdStatus }}</p>
                <p *ngIf="holdReleaseDate"><span class="holdIcon"><img src="../../../../assets/images/cox-icons/blue-info-icon.svg" alt="Icon"></span><span>Hold Release Date - </span>{{ holdReleaseDate | date:'MM/dd/yyyy' }}</p>
                <p *ngIf="holdReason"><span class="holdIcon"><img src="../../../../assets/images/cox-icons/blue-info-icon.svg" alt="Icon"></span><span>Hold Reason - </span>{{ holdReason }}</p>
                <p *ngIf="status"><span class="holdIcon"><img src="../../../../assets/images/cox-icons/time.svg" alt="Icon"></span>{{ status }}</p>
                <p *ngIf="offsite"><span class="holdIcon"><img src="../../../../assets/images/cox-icons/blue-info-icon.svg" alt="Icon"></span>{{ offsite }}</p>

            </div>
        </div>
    </div>
    
</div>